import { render, staticRenderFns } from "./provider-assignments-table.vue?vue&type=template&id=49791f46"
import script from "./provider-assignments-table.vue?vue&type=script&lang=js"
export * from "./provider-assignments-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports